import { createFileRoute, redirect } from '@tanstack/react-router';

import { CLINICAL_LANDING } from '@/lib/constants';

export const Route = createFileRoute('/app/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: CLINICAL_LANDING, replace: true });
  },
});
